import React from 'react';

interface ArrowProps {
    size?: number;
}

export const Arrow: React.FC<ArrowProps> = ({ size }) => {
    const viewBoxWidth = 71;
    const viewBoxHeight = 72;
    return (
        <svg
            className="double__arrow"
            width={`${size}px`}
            height={`${size}px`}
            viewBox={`0 0 ${viewBoxWidth} ${viewBoxHeight}`}
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
        >
            <title>arrow</title>
            <defs>
                <linearGradient x1="74.0351393%" y1="46.430406%" x2="2.87964097e-14%" y2="46.430406%" id="linearGradient-1">
                    <stop stopColor="#DD7500" offset="0%"></stop>
                    <stop stopColor="#FFED55" offset="100%"></stop>
                </linearGradient>
                <polygon id="path-2" points="9.372583 9.372583 54.627417 27.9621842 35.983486 35.7179202 27.9621842 54.627417"></polygon>
                <linearGradient x1="74.0351393%" y1="46.430406%" x2="2.87964097e-14%" y2="46.430406%" id="linearGradient-4">
                    <stop stopColor="#DD7500" offset="0%"></stop>
                    <stop stopColor="#FFED55" offset="100%"></stop>
                </linearGradient>
                <linearGradient x1="80.955169%" y1="27.2340941%" x2="24.8056496%" y2="84.6949433%" id="linearGradient-5">
                    <stop stopColor="#FFF400" offset="0%"></stop>
                    <stop stopColor="#FF9A00" offset="45.3698645%"></stop>
                    <stop stopColor="#FFE400" offset="100%"></stop>
                </linearGradient>
                <polygon id="path-6" points="9.372583 9.372583 54.627417 27.9621842 35.983486 35.7179202 27.9621842 54.627417"></polygon>
                <filter x="-9.6%" y="-9.6%" width="120.9%" height="120.8%" filterUnits="objectBoundingBox" id="filter-8">
                    <feGaussianBlur stdDeviation="2.5" in="SourceAlpha" result="shadowBlurInner1"></feGaussianBlur>
                    <feOffset dx="0" dy="0" in="shadowBlurInner1" result="shadowOffsetInner1"></feOffset>
                    <feComposite
                        in="shadowOffsetInner1"
                        in2="SourceAlpha"
                        operator="arithmetic"
                        k2="-1"
                        k3="1"
                        result="shadowInnerInner1"
                    ></feComposite>
                    <feColorMatrix
                        values="0 0 0 0 1   0 0 0 0 0.802447552   0 0 0 0 0  0 0 0 1 0"
                        type="matrix"
                        in="shadowInnerInner1"
                    ></feColorMatrix>
                </filter>
            </defs>
            <g id="UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="Elements" transform="translate(-566.000000, -146.000000)">
                    <g
                        id="arrow"
                        transform="translate(601.000000, 182.000000) scale(-1, 1) rotate(-90.000000) translate(-601.000000, -182.000000) translate(569.000000, 150.000000)"
                    >
                        <mask id="mask-3" fill="white">
                            <use
                                xlinkHref="#path-2"
                                transform="translate(32.000000, 32.000000) scale(1, -1) rotate(45.000000) translate(-32.000000, -32.000000) "
                            ></use>
                        </mask>
                        <use
                            id="Mask"
                            fill="url(#linearGradient-1)"
                            transform="translate(32.000000, 32.000000) scale(1, -1) rotate(45.000000) translate(-32.000000, -32.000000) "
                            xlinkHref="#path-2"
                        ></use>
                        <polygon id="Path" fill="url(#linearGradient-4)" mask="url(#mask-3)" points="57 14 57 66 32 66 32 14"></polygon>
                        <mask id="mask-7" fill="white">
                            <use
                                xlinkHref="#path-6"
                                transform="translate(32.000000, 32.000000) scale(1, -1) rotate(45.000000) translate(-32.000000, -32.000000) "
                            ></use>
                        </mask>
                        <g id="Mask" transform="translate(32.000000, 32.000000) scale(1, -1) rotate(45.000000) translate(-32.000000, -32.000000) ">
                            <use fill="black" fillOpacity="1" filter="url(#filter-8)" xlinkHref="#path-6"></use>
                            <path
                                stroke="url(#linearGradient-5)"
                                strokeWidth="1"
                                d="M8.4552057,8.4552057 L55.9362208,27.9592687 L36.3640492,36.1011459 L27.9547691,55.9252667 L8.4552057,8.4552057 Z"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
